export default function signupSuccess(state, payload) {
  const {
    hasCharacter,
    privilegeLevel,
    user,
  } = payload;

  return {
    ...state,
    hasCharacter,
    privilegeLevel,
    user,
    isFetching: false,
    loggedIn: true,
  };
}